import Tasks from 'APP/Tasks';
import { IScheduledMessage } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';

export function updateScheduledMessages(groupId: string, messages: IScheduledMessage[] = []): void {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  const scheduledGroupId = group.scheduleGroupId;
  const userId = Entities.usersStore.Me.id;

  Tasks.messaging.updateOldOrFakeMessages({
    groupId: scheduledGroupId,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: fix typings after scheduled messages refactor
    messages: messages.map((msg) => ({
      ...msg,
      senderId: userId,
      groupId: scheduledGroupId,
      clientTime: parseInt(msg.clientTime), //save client time now
      // ToDo: [SCHEDULED MESSAGES]: временный фикс бага GEM-35353
      // ToDo: [SCHEDULED MESSAGES]: переработать работу с clientTime и serverTime
      // оставив delay, так как это влияет на расчет времени отправки при редактировании
      // сообщения
      serverTime: parseInt(msg.clientTime) + parseInt(msg.delay),
    })),
  });
}
